// extracted by mini-css-extract-plugin
export default {"backdrop":"XSdeOAqxsmR1Eow8getI","upsellState":"YoOov37FzBFtRrBnPhw5u","title":"_3Tsjv13qME3QsBstVyZSIn","description":"-NrSSF-X8Gjg1Xz-WcaAB"};